/**
 * 막힘 지점 측정 세션 키(specs/071 research R2) — 탭 세션(sessionStorage)마다 무작위 UUID. 로그인 정보와 잇지 않으며 서버는 해시만 저장한다.
 * 저장소를 못 쓰는 환경(사생활 보호 모드 등)이면 null — 측정만 빠지고 화면은 그대로다.
 */
const KEY = 'ad-session';

export const FRICTION_SESSION_HEADER = 'X-AD-Session';

export function frictionSessionId(): null | string {
  try {
    const saved = sessionStorage.getItem(KEY);
    if (saved) return saved;
    const created = crypto.randomUUID();
    sessionStorage.setItem(KEY, created);
    return created;
  } catch {
    return null;
  }
}
